app.component('categoryTitle', {
    template: '<style>'+
              '.category_wrap { padding: 10px 13px; color:#03a9f4; background-color: #B3E5FC }'+
              '.category_title { position: relative; top:2px; }'+
              '</style>'+
              '<div class="category_wrap">'+
              '    <md-icon md-svg-icon="{{$ctrl.icon}}"></md-icon>'+
              '    <span class="md-subhead category_title">{{$ctrl.title}}</span>'+
              '</div>'
    ,
    bindings: {
        "title" : '@',
        "icon" : "@"
    }
});
